import CryptoJS from 'crypto-js';

const SECRET_KEY = process.env.REACT_APP_API_ENCRYPTION_KEY;

export const SecureStorage = {
  // Encrypt data before storing
  setItem(key, data) {
    const encryptedData = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      SECRET_KEY
    ).toString();
    localStorage.setItem(key, encryptedData);
  },

  // Decrypt data when retrieving
  getItem(key) {
    const encryptedData = localStorage.getItem(key);
    if (!encryptedData) return null;
    
    const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
    try {
      return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } catch {
      return null;
    }
  }
}; 